import React from 'react';

import { ErrorMessage } from '@atlaskit/form';
import Spinner from '@atlaskit/spinner';

import { PipelinesTimeseriesErrors } from 'src/components/pipelines/hooks/use-pipelines-timeseries';
import { useIntl } from 'src/hooks/intl';

import { messages } from '../metric-cards/i18n';
import { MetricCard } from '../metric-cards/metric-card';
import { MessageWrapper, SpinnerWrapper } from '../metric-cards/styles';

type ChartWrapperProps = {
  children: React.ReactNode;
  chartTitle: string;
  isLoading: boolean;
  error?: PipelinesTimeseriesErrors;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const ChartWrapper: React.FC<ChartWrapperProps> = ({
  chartTitle,
  children,
  isLoading,
  error,
}) => {
  const { formatMessage } = useIntl();

  if (isLoading) {
    return (
      <MetricCard label={chartTitle}>
        <SpinnerWrapper data-testid="average-build-loading-spinner">
          <Spinner size="medium" />
        </SpinnerWrapper>
      </MetricCard>
    );
  }

  if (error === PipelinesTimeseriesErrors.LoadFail) {
    return (
      <MetricCard label={chartTitle}>
        <MessageWrapper>
          <ErrorMessage>
            {formatMessage(messages.chartLoadFailedText)}
          </ErrorMessage>
        </MessageWrapper>
      </MetricCard>
    );
  }

  if (error === PipelinesTimeseriesErrors.NoData) {
    return (
      <MetricCard label={chartTitle}>
        <MessageWrapper>
          {formatMessage(messages.noDataMessageText)}
        </MessageWrapper>
      </MetricCard>
    );
  }

  return <MetricCard label={chartTitle}>{children}</MetricCard>;
};
